import { Component, Input, Output, EventEmitter, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HistoryComponent {

  @Input() historyData:any = null;
  @Input() tdsWidth: string[];
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();

  hideHistory() {
    this.closed.emit();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/history/history.component.ts